import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatChipsModule } from '@angular/material/chips';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatSliderModule } from '@angular/material/slider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatStepperModule } from '@angular/material/stepper';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { LayoutModule } from '@angular/cdk/layout';
import { BigInputComponent } from './big-input/big-input/big-input.component';
import { BigInputActionComponent } from './big-input/big-input-action/big-input-action.component';
import { RtlSupportDirective } from './rtl-support/rtl-support.directive';
import { AliveClient, VideoClient } from './http-clients/http-clients';
import { NgxPermissionsModule } from 'ngx-permissions';
//import { NgDialogAnimationService } from 'ng-dialog-animation';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FilterByPipe } from './pipes/filter.pipe';
import { DateAdapter as SatDateAdapter, MAT_DATE_FORMATS as SAT_DATE_FORMATS, MAT_DATE_LOCALE as SAT_DATE_LOCALE, SatDatepickerModule } from 'saturn-datepicker-ext';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faBook,
  faBuilding,
  faCalendar,
  faCalendarAlt,
  faCalendarPlus,
  faCaretDown,
  faCaretUp,
  faCheck,
  faChevronDown,
  faClinicMedical,
  faClock,
  faCog,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEraser,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFile,
  faFileDownload,
  faFileImport,
  faFilter,
  faGlobe,
  faInfo,
  faLanguage,
  faLightbulb,
  faList,
  faLock,
  faMap,
  faMapMarkerAlt,
  faMicrophone,
  faMicrophoneSlash,
  faMinus,
  faNotesMedical,
  faPaintBrush,
  faPaperPlane,
  faPhone,
  faPlayCircle,
  faPlus,
  faPowerOff,
  faRocket,
  faSave,
  faSearch,
  faSlidersH,
  faSquare,
  faStop,
  faStream,
  faTasks,
  faThumbtack,
  faTimes,
  faTrash,
  faUnlock,
  faUnlockAlt,
  faUserCircle,
  faUserMinus,
  faUserNurse,
  faVideo,
  faVideoSlash,
  faWalking,
  faWindowMaximize,
  faCheckCircle,
  faCopy,
  faCalendarDay
} from '@fortawesome/free-solid-svg-icons';
import { faGithub, faMediumM, faTwitter, faInstagram, faYoutube, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { MatFormFieldRequiredDirective } from '@shared/directives/mat-form-field-required/mat-form-field-required.directive';
import { FiltersButtonComponent } from './components/filters-button/filters-button.component';
import { SpeedDialFabComponent } from './components/speed-dial-fab/speed-dial-fab.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { SexService } from './services/sex.service';
import { HighlightSearchPipe } from './pipes/highlight.pipe';
import { MatFormFieldClearButtonComponent } from './components/mat-form-field-clear-button/mat-form-field-clear-button.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { LoginDataService } from '@features/login/login-data.service';
import { ResetPasswordService } from './services/resetpassword.service';
import { ResetPasswordDataService } from './services/resetpassworddata.service';
import { MatBadgeModule } from '@angular/material/badge';
import { CachedInnerHtmlDirective } from './directives/cached-inner-html/cached-inner-html.directive';
import { VideoChatService } from '../features/video-chat/services/video-chat.service';
import { ConfirmDialogService } from '@core/notifications/confirm-dialog-notification/confirm-dialog-notification.service';
import { LoginService } from '@features/login/login.service';
import { MatPaginatorI18nService } from './mat-paginator-i18n.service';
import { PasswordStrengthBarComponent } from './components/password-strength-bar/password-strength-bar.component';
import { LocationFormComponent } from './components/location-form/location-form.component';
import { TimeSlotComponent } from '@features/add-booking/time-slot/time-slot.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { PopoverService } from 'app/services/common/popover.service';
import { LayoutService } from 'app/services/common/layout.service';
import { PopoverComponent } from './popover/popover.component';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FileSizePipe } from './pipes/file-size.pipe';
import { GoogleMapsModule } from '@angular/google-maps';
import { DigitsOnlyDirective } from './directives/digits-only/digits-only.directive';

export const KailoMatDateFormats = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatButtonToggleModule,
    MatToolbarModule,
    MatSelectModule,
    MatTabsModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatChipsModule,
    MatCardModule,
    MatSidenavModule,
    MatCheckboxModule,
    MatListModule,
    MatMenuModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatTableModule,
    MatPaginatorModule,
    MatStepperModule,
    NgxMatSelectSearchModule,
    MatExpansionModule,
    LayoutModule,
    MatPaginatorModule,
    CKEditorModule,
    MatRadioModule,
    MatSelectModule,
    FontAwesomeModule,
    MatDatepickerModule,
    NgxMaterialTimepickerModule,
    SatDatepickerModule,
    ReactiveFormsModule,
    MatBadgeModule,
    GoogleMapsModule
  ],
  declarations: [
    BigInputComponent,
    BigInputActionComponent,
    RtlSupportDirective,
    FilterByPipe,
    MatFormFieldRequiredDirective,
    FiltersButtonComponent,
    SpeedDialFabComponent,
    BackButtonComponent,
    HighlightSearchPipe,
    MatFormFieldClearButtonComponent,
    ResetPasswordComponent,
    CachedInnerHtmlDirective,
    PasswordStrengthBarComponent,
    LocationFormComponent,
    TimeSlotComponent,
    PopoverComponent,
    FileSizePipe,
    DigitsOnlyDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatMenuModule,
    MatTabsModule,
    MatChipsModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    MatCardModule,
    MatSidenavModule,
    MatListModule,
    MatSelectModule,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatDividerModule,
    MatSliderModule,
    MatDatepickerModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatTableModule,
    MatPaginatorModule,
    MatStepperModule,
    NgxMatSelectSearchModule,
    MatExpansionModule,
    LayoutModule,
    MatPaginatorModule,
    CKEditorModule,
    MatRadioModule,
    MatSelectModule,
    FontAwesomeModule,
    BigInputComponent,
    BigInputActionComponent,
    RtlSupportDirective,
    NgxPermissionsModule,
    FilterByPipe,
    SatDatepickerModule,
    MatFormFieldRequiredDirective,
    FiltersButtonComponent,
    SpeedDialFabComponent,
    BackButtonComponent,
    HighlightSearchPipe,
    MatFormFieldClearButtonComponent,
    ResetPasswordComponent,
    MatBadgeModule,
    CachedInnerHtmlDirective,
    PasswordStrengthBarComponent,
    LocationFormComponent,
    TimeSlotComponent,
    FileSizePipe,
    GoogleMapsModule,
    DigitsOnlyDirective
  ],
  providers: [
    AliveClient,
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: KailoMatDateFormats },
    { provide: SatDateAdapter, useClass: MomentDateAdapter, deps: [SAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: SAT_DATE_FORMATS, useValue: KailoMatDateFormats },
    SexService,
    ResetPasswordService,
    LoginService,
    ResetPasswordDataService,
    LoginDataService,
    VideoChatService,
    VideoClient,
    ConfirmDialogService,
    PopoverService,
    LayoutService,
    { provide: MatPaginatorIntl, useClass: MatPaginatorI18nService },
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} }
  ],
  entryComponents: [
    PopoverComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      faBars,
      faUserCircle,
      faPowerOff,
      faCog,
      faRocket,
      faPlayCircle,
      faGithub,
      faMediumM,
      faTwitter,
      faInstagram,
      faYoutube,
      faPlus,
      faEdit,
      faTrash,
      faTimes,
      faCaretUp,
      faCaretDown,
      faExclamationTriangle,
      faFilter,
      faTasks,
      faCheck,
      faSquare,
      faLanguage,
      faPaintBrush,
      faLightbulb,
      faWindowMaximize,
      faStream,
      faBook,
      faChevronDown,
      faSave,
      faUnlockAlt,
      faSearch,
      faCalendar,
      faEnvelope,
      faLock,
      faUnlock,
      faDownload,
      faEraser,
      faEye,
      faEyeSlash,
      faMinus,
      faEdit,
      faFileImport,
      faInfo,
      faBuilding,
      faWalking,
      faSlidersH,
      faFile,
      faClock,
      faNotesMedical,
      faClinicMedical,
      faUserNurse,
      faMap,
      faList,
      faArrowLeft,
      faStop,
      faPhone,
      faMicrophone,
      faMicrophoneSlash,
      faVideo,
      faVideoSlash,
      faPaperPlane,
      faThumbtack,
      faArrowRight,
      faGlobe,
      faMapMarkerAlt,
      faFacebookF,
      faLinkedinIn,
      faCalendarPlus,
      faEllipsisV,
      faCalendarAlt,
      faUserMinus,
      faFileDownload,
      faCheckCircle,
      faCopy,
      faCalendarDay
    );
  }
}

